import React, { Component } from 'react';
import { TransparentButton, TextButton } from '@checkmarx/cx-ui';
import ActionResult from '../actionResult';
import classNames from 'classnames';
import styles from './style.scss';

export default class LdapTestConnectionButton extends Component {
  
    render() {

        return(
            
            <div className={classNames(styles.testConnectionWrapper)}>
                
                {
                    this.props.testMessage ? 
                    null : 
                    <div>
                        <TransparentButton 
                            style={{
                                height: 25,
                                lineHeight: '24px'
                            }} 
                            dataCy={`ldap-test-connection`}
                            type='button'
                            onClick={this.props.performTestConnection}
                            text={this.props.label} 
                            inProgress={this.props.isInProgress}/>
                    </div>                   
                }  
                             
                {
                    this.props.testMessage ?                        
                            <ActionResult 
                                text={this.props.testMessage}
                                error={!this.props.isTestSuccessful}
                            />
                                : null
                }                            
                
                {
                    this.props.testMessage ?   
                        <span>                                                    
                            <span className={classNames(styles.devider)}>
                            | 
                            </span>
                            <span>
                                <TextButton 
                                    text={this.props.translations.recheck}
                                    onClick={this.props.performTestConnection}
                                    dataCy='btn-recheck-connection'
                                />
                            </span>
                        </span>

                    : null
                }                
               
            </div>
        );
    }
}